module.exports = __webpack_public_path__ + "img/ai-white-icon.50287937.svg";